import React from 'react';

const Label: React.SFC<{ className?: string }> = props => (
  <div className={props.className ? `sk-label ${props.className}` : 'sk-label'}>{props.children}</div>
);

export default Label;
